import React, { useEffect } from "react";
import ImageWithBasePath from "../../core/common/imageWithBasePath";
import { Link, useNavigate } from 'react-router-dom'
import { all_routes } from "../router/all_routes";
import TextField from "../../core/common/textFields/TextField";
import { useForgotPasswordMutation, useLoginUserMutation } from "../../services/EndPointsApis";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";

const ForgotPassword = () => {
  const route = all_routes;
  const navigate = useNavigate()
  const [forgotPassword, { data, isError, error, isSuccess, isLoading }] =
    useForgotPasswordMutation();

  //formik

  const forgotSchema = Yup.object().shape({
    email: Yup.string()
      .email("Wrong email format")
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required("Email is required"),
  });

  const initialValues = {
    email: "",
  };
  const formik = useFormik({
    initialValues,
    validationSchema: forgotSchema,

    onSubmit: (values) => {
      forgotPassword(values)
    }
  })

  const handleSubmit = () => {
    formik.handleSubmit()
  }

  useEffect(() => {
    if (isSuccess) {
      toast.success(data?.result);
    }
  }, [isSuccess]);

  useEffect(() => {
    if (isError && error) {
      let errorMessage: string = 'Something went wrong';

      if ('data' in error && error.data && typeof error.data === 'object' && 'message' in error.data) {
        errorMessage = (error.data as { message: string }).message;
      }
      toast.error(errorMessage);
    }
  }, [isError, error]);

  return (
    <div className="account-content" >
      <div className="login-wrapper ">
        <div className="login-content">
          <div className="d-flex flex-column justify-content-center h-100 w-100">
            <div className="login-user-info">
              <div className="login-logo d-flex justify-content-center">
                <ImageWithBasePath
                  src="assets/img/logo.svg"
                  className="img-fluid"
                  alt="Logo"
                />
              </div>
              <div className="row justify-content-center">
                <div className="col-md-8 ">
                  <div className="login-heading">
                    <h4>Forgot Password?</h4>
                    <p>
                      Enter your email to reset password
                    </p>
                  </div>
                  <div className="form-wrap">
                    <div className="form-wrap-icon">
                      <TextField
                        label="Email Address"
                        required
                        type="email"
                        placeholder="Enter Email"
                        {...formik.getFieldProps('email')}
                      />
                      <i className="ti ti-mail" />
                    </div>
                  </div>
                  {formik.touched.email && formik.errors.email && (
                    <div className="error">{formik.errors.email}</div>
                  )}
                  <div className="form-wrap">
                    <button className="btn btn-primary" onClick={handleSubmit}>
                      Submit
                    </button>
                  </div>
                  <div className="login-form ">
                    <h6>
                      Back to
                      <Link to={route.login} className="hover-a">
                        {" "}
                        Log In
                      </Link>
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="copyright-text ">
            <p className="">Copyright ©1958 - AIROOM</p>
          </div>
        </div>
        <div className="w-50 login-img ">
        </div>
      </div>
    </div >
  );
};

export default ForgotPassword;
